import { STATSIG_ENVIRONMENT } from "@/config";
import { StatsigOptions } from "@statsig/react-bindings";

/**
 * Client-side Statsig options.
 *
 * v1's `overrideStableID` is gone and isn't needed: the client calls
 * `StableID.setOverride` itself for any user carrying `customIDs.stableID`,
 * which `createStatsigUser` always sets to the device ID. Bucketing is
 * therefore unchanged by the v3 upgrade.
 */
export const getStatsigOptions = (): StatsigOptions => {
  return {
    environment: { tier: STATSIG_ENVIRONMENT },
  };
};
